import React from 'react'

import classnames from 'classnames'
import PropTypes from 'prop-types'

import OrderSummary from 'containers/welcome/OrderSummary'

import { ReferAFriend } from '../OrderConfirmation/components/ReferAFriend'
import { AppPromo } from './AppPromo'
import { OrderSchedule } from './OrderSchedule'

import css from './Welcome.css'

const propTypes = {
  device: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  params: PropTypes.shape({
    orderId: PropTypes.string,
  }).isRequired,
  query: PropTypes.shape({
    var: PropTypes.string,
  }).isRequired,
  trackWelcomeAppPromoClick: PropTypes.func.isRequired,
  userFetchReferralOffer: PropTypes.func.isRequired,
  addRecipeToBasket: PropTypes.func.isRequired,
  userLoadData: PropTypes.func.isRequired,
}

class Welcome extends React.PureComponent {
  componentDidMount() {
    const {
      query = {},
      params = {},
      fetchData,
      addRecipeToBasket,
      userFetchReferralOffer,
      userLoadData,
    } = this.props

    userLoadData()
    userFetchReferralOffer()
    fetchData({ query, params }, addRecipeToBasket)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    const { device, trackWelcomeAppPromoClick } = this.props

    return (
      <section className={css.container} data-testid="welcomeContainer">
        <div className={classnames(css.contentContainer)}>
          <div className={css.row}>
            <div className={css.colMedium}>
              <div className={css.welcomeColInnerContainer}>
                <OrderSchedule />
                <div className={classnames(css.welcomeColInner, css.appPromo)}>
                  <AppPromo device={device} trackWelcomeAppPromoClick={trackWelcomeAppPromoClick} />
                </div>
              </div>
              <div className={classnames(css.welcomeColInner, css.mobileShow, css.rafMobile)}>
                <ReferAFriend />
              </div>
            </div>
            <div className={classnames(css.colSmall, css.mobileHide)}>
              <div className={classnames(css.welcomeColInner, css.orderSummaryWrapper)}>
                <OrderSummary />
              </div>
              <div className={classnames(css.welcomeColInner)}>
                <ReferAFriend />
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

Welcome.propTypes = propTypes

export { Welcome }
